export default __webpack_public_path__ + "static/media/B_Bermuda.8502528a.mp3";